import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CreditProcessStatus, Personality } from 'src/app/@core/constants';
import { CreditRequest } from 'src/app/models/credit-request';
import { Customer } from 'src/app/models/customer';
import { CreditStatusFranchisedResponseModel } from 'src/app/models/response/customerCreditStatusResponseModel';
import { OnbaseProcedureResponseModel } from 'src/app/models/response/onbaseProcedureResponseModel';
import { User } from 'src/app/models/user';
import { CreditService } from 'src/app/services/credit.service';
import { ExceptionSolutionService } from 'src/app/services/exception-solution.service';
import { OnbaseService } from 'src/app/services/onbase.service';

@Component({
  selector: 'app-modify-credit-request',
  templateUrl: './modify-credit-request.component.html',
  styleUrls: ['./modify-credit-request.component.sass']
})
export class ModifyCreditRequestComponent implements OnInit {

  constructor(private router: Router, private toastrService: ToastrService, private route: ActivatedRoute, private onbaseService: OnbaseService, private creditService: CreditService, private readonly exceptionSolutionService: ExceptionSolutionService) {

  }
  request: CreditRequest = new CreditRequest();
  creditPlan: OnbaseProcedureResponseModel = new OnbaseProcedureResponseModel();
  validateSendPersonPlans(request: CreditRequest, creditPlan?: OnbaseProcedureResponseModel, customerCreditConditions?: CreditStatusFranchisedResponseModel, customer?: Customer, seller?: User) {
    switch (request.procedure) {
      case "0001":
        this.router.navigate(["creditRequests", `modify`, request.code, "fastTrackPerson"],
          {
            state: {
              request: request,
              creditPlan: creditPlan,
              customerCreditConditions: customerCreditConditions,
              customer: customer,
              seller: seller,
              isDraft: true
            }
          });
        break;
      case "0002":
        this.router.navigate(["creditRequests", `modify`, request.code, "immediateProcedurePerson"],
          {
            state: {
              request: request,
              creditPlan: creditPlan,
              customerCreditConditions: customerCreditConditions,
              customer: customer,
              seller: seller,
              isDraft: true
            }
          });
        break;
      case "0003":
        this.router.navigate(["creditRequests", `modify`, request.code, "nbaPlan"],
          {
            state: {
              request: request,
              creditPlan: creditPlan,
              customerCreditConditions: customerCreditConditions,
              customer: customer,
              seller: seller,
              isDraft: true
            }
          });
        break;
      case "0004":
        this.router.navigate(["creditRequests", `modify`, request.code, "guaranteedPerson"],
          {
            state: {
              request: request,
              creditPlan: creditPlan,
              customerCreditConditions: customerCreditConditions,
              customer: customer,
              seller: seller,
              isDraft: true
            }
          });
        break;
      case "0005":
        this.router.navigate(["creditRequests", `modify`, request.code, "normalPerson"],
          {
            state: {
              request: request,
              creditPlan: creditPlan,
              customerCreditConditions: customerCreditConditions,
              customer: customer,
              seller: seller,
              isDraft: true
            }
          });
        break;
      case "0006":
        this.router.navigate(["creditRequests", `modify`, request.code, "creditAnalysisPerson"],
          {
            state: {
              request: request,
              creditPlan: creditPlan,
              customerCreditConditions: customerCreditConditions,
              customer: customer,
              seller: seller,
              isDraft: true
            }
          });
        break;
      case "0007":
        this.router.navigate(["creditRequests", `modify`, request.code, "employeePerson"],
          {
            state: {
              request: request,
              creditPlan: creditPlan,
              customerCreditConditions: customerCreditConditions,
              customer: customer,
              seller: seller,
              isDraft: true
            }
          });
        break;
      case "0008":
        this.router.navigate(["creditRequests", `modify`, request.code, "agreementPerson"],
          {
            state: {
              request: request,
              creditPlan: creditPlan,
              customerCreditConditions: customerCreditConditions,
              customer: customer,
              seller: seller,
              isDraft: true
            }
          });
        break;
      case "0010":
        this.router.navigate(["creditRequests", "modify", request.code, "franchisedEntityPlan"],
          {
            state: {
              request: request,
              creditPlan: creditPlan,
              customerCreditConditions: customerCreditConditions,
              customer: customer,
              seller: seller,
              isDraft: true
            }
          })
        break;
      default:
        this.exceptionSolutionService.showAlertWithSolution(`Solicitud de Crédito`, `Plan de credito ${request.procedure || ""} invalido. Contactar al equipo de soporte`, undefined, 'error');
        this.router.navigate(['customer'])
        break;
    }
  }

  validateSendLegalEntityPlans(request: CreditRequest, creditPlan?: OnbaseProcedureResponseModel, customerCreditConditions?: CreditStatusFranchisedResponseModel, customer?: Customer, seller?: User) {
    switch (request.procedure) {
      case "0006":
        this.router.navigate(["creditRequests", `modify`, request.code, "creditAnalisisLegalEntity"],
          {
            state: {
              request: request,
              creditPlan: creditPlan,
              customerCreditConditions: customerCreditConditions,
              customer: customer,
              seller: seller,
              isDraft: true
            }
          });
        break;
      case "0008":
        this.router.navigate(["creditRequests", `modify`, request.code, "agreementLegalEntity"],
          {
            state: {
              request: request,
              creditPlan: creditPlan,
              customerCreditConditions: customerCreditConditions,
              customer: customer,
              seller: seller,
              isDraft: true
            }
          });
        break;
      case "0010":
        this.router.navigate(["creditRequests", "modify", request.code, "legalEntityPlan"],
          {
            state: {
              request: request,
              creditPlan: creditPlan,
              customerCreditConditions: customerCreditConditions,
              customer: customer,
              seller: seller,
              isDraft: true
            }
          })
        break;
      case "0009":
        this.router.navigate(["creditRequests", "modify", request.code, "thirtyDaysLegalEntity"],
          {
            state: {
              request: request,
              creditPlan: creditPlan,
              customerCreditConditions: customerCreditConditions,
              customer: customer,
              seller: seller,
              isDraft: true
            }
          })
        break;
      default:
        this.exceptionSolutionService.showAlertWithSolution(`Solicitud de Crédito`, `Plan de credito ${request.procedure || ""} invalido. Contactar al equipo de soporte`, undefined, 'error');
        this.router.navigate(['customer'])
        break;
    }
  }
  async ngOnInit(): Promise<void> {
    if (this.route.snapshot.params.creditRequestNumber == undefined) {
      this.router.navigate(['customer']);
      return;
    }
    let request = (await this.onbaseService.readOnbaseRequestByCode(this.route.snapshot.params.creditRequestNumber).toPromise()).response;
    if (request == undefined) {
      this.router.navigate(['customer']);
      return;
    }
    let personality = request.customer.mainPersonalInfo?.personality;
    let creditPlan = (await this.onbaseService.readCreditPlans().toPromise()).response.content.find(f => f.code == request.procedure);
    let customerCreditConditions = (await this.creditService.getCustomerCreditStatus(request.customer, request.branchCode, request.seller.username).toPromise());
    let customer = request.customer;
    let seller = request.seller;
    this.request = request;
    this.creditPlan = creditPlan || new OnbaseProcedureResponseModel();
    creditPlan!.credit = parseFloat(request.requestData.Monto_Sugerido_Credito);

    if (request.processingStatus != CreditProcessStatus.DRAFT) {
      this.exceptionSolutionService.showAlertWithSolution(`Solicitud de Crédito ${this.request.code}`, `Solicitud no se puede modificar porque ya esta creada`);
      this.router.navigate(["creditRequests", request.code]);
      return;
    }
    if (personality == Personality.PERSON) {
      this.validateSendPersonPlans(request, creditPlan, customerCreditConditions, customer, seller);

    }
    else if (personality == Personality.LEGAL_ENTITY) {
      this.validateSendLegalEntityPlans(request, creditPlan, customerCreditConditions, customer, seller);
    }
  }

}
